// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2CBtK","errors":"Errors_errors__1Keqr"};